import { BlockNodeData } from "./blockNodeData.js";
import { InputBlock, ConnectionPointType, createStrongRef, createImageTexture } from "smart-filters";
import "core/Engines/Extensions/engine.dynamicTexture.js";
import "core/Engines/Extensions/engine.videoTexture.js";
/**
 * Creates a default value for the input block of a certain type
 * @param type - defines the type of the input block
 * @param engine - defines the engine to use to create a texture (if relevant)
 * @returns a strong ref containing the default value
 */
export function CreateDefaultValue(type, engine) {
    // conversion needed due to https://github.com/microsoft/TypeScript/issues/33014
    switch (type) {
        case ConnectionPointType.Boolean:
            return createStrongRef(false);
        case ConnectionPointType.Float:
            return createStrongRef(0);
        case ConnectionPointType.Color3:
            return createStrongRef({ r: 0, g: 0, b: 0 });
        case ConnectionPointType.Color4:
            return createStrongRef({ r: 0, g: 0, b: 0, a: 0 });
        case ConnectionPointType.Vector2:
            return createStrongRef({ x: 0, y: 0 });
        case ConnectionPointType.Texture:
            return createStrongRef(engine ? createImageTexture(engine, "/assets/logo.png") : null);
        default:
            throw new Error(`Unknown connection point type ${type}`);
    }
}
/**
 * Creates a default input block for a certain type
 * @param smartFilter - defines the smart filter to attach the input block to
 * @param type - defines the type of the input block
 * @param engine - defines the engine to use to create a texture (if relevant)
 * @param name - if supplied, used as the name of the input block, otherwise it will be named after the data type
 * @returns
 */
export function CreateDefaultInput(smartFilter, type, engine, name) {
    const blockName = name ?? ConnectionPointType[type] ?? "Unknown";
    const inputBlock = new InputBlock(smartFilter, blockName, type, CreateDefaultValue(type, engine));
    return inputBlock;
}
/**
 * Creates a default input block for a certain connection point
 * @param smartFilter - defines the smart filter to attach the input block to
 * @param point - defines the connection point to create the input block for
 * @param engine - defines the engine to use to create a texture (if relevant)
 * @returns The created input block
 */
export function CreateDefaultInputForConnectionPoint(smartFilter, point, engine) {
    const name = point.name;
    const inputBlock = new InputBlock(smartFilter, name, point.type, point.defaultRuntimeData ? createStrongRef(structuredClone(point.defaultRuntimeData.value)) : CreateDefaultValue(point.type, engine));
    return inputBlock;
}
export const RegisterDefaultInput = (stateManager) => {
    stateManager.createDefaultInputData = (rootData, portData, nodeContainer) => {
        const point = portData.data;
        // const customInputBlock = point.createCustomInputBlock();
        const pointName = "output";
        // let emittedBlock;
        const globalState = rootData;
        const smartFilter = globalState.smartFilter;
        // if (!customInputBlock) {
        // if (point.type === SmartFilterConnectionPointTypes.AutoDetect) {
        //     return null;
        // }
        const emittedBlock = CreateDefaultInputForConnectionPoint(smartFilter, point, globalState.engine);
        // } else {
        //     [emittedBlock, pointName] = customInputBlock;
        // }
        // TODO. Dynamic block creation
        // smartFilter.attachedBlocks.push(emittedBlock);
        // if (!emittedBlock.isInput) {
        //     emittedBlock.autoConfigure(smartFilter);
        // }
        return {
            data: new BlockNodeData(emittedBlock, nodeContainer),
            name: pointName,
        };
    };
};
//# sourceMappingURL=registerDefaultInput.js.map